import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import { CREATION_ID } from '../../editor/editorSlice';
import CommentThreadCompactAvatarStack from './CommentThreadCompactAvatarStack';
import showFullPageSheet from './showFullPageSheet';
import { usePostLayoutSize } from '../PostLayoutProvider';
import { isFeatureEnabled } from '../../utils/features';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const THREAD_FRAGMENT = gql(`
  fragment CommentThreadCompact_thread on PublicThreadFields {
    id
    comments {
      id
      ...CommentThreadCompactAvatarStack_comment
    }
  }
`);

interface CommentThreadCompactProps {
  thread: DocumentType<typeof THREAD_FRAGMENT>;
  isFocused: boolean;
}

const CommentThreadCompact = ({
  thread,
  isFocused,
}: CommentThreadCompactProps) => {
  const postLayoutSize = usePostLayoutSize();
  const canOnlyShowOne = isFeatureEnabled('new_post_layout')
    ? postLayoutSize === 'mobile'
    : ['mobile', 'narrow'].includes(postLayoutSize);
  const currentUser = useAppSelector((state) => state.session.user);

  const avatarStackItems =
    thread.id === CREATION_ID
      ? [{ id: currentUser.id, author: currentUser }]
      : thread.comments;

  const hasRing = isFocused && showFullPageSheet();

  return (
    <CommentThreadCompactAvatarStack
      comments={
        canOnlyShowOne ? avatarStackItems.slice(0, 1) : avatarStackItems
      }
      ring={hasRing}
    />
  );
};

export default CommentThreadCompact;
